'use strict';

angular.module('uuid', []).service('uuid4', function () {
    /**! http://stackoverflow.com/a/2117523/377392 */
    var fmt = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    this.generate = function () {
        return fmt.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
});

var m = angular.module('jsonrpc', ['uuid']);

m.provider('jsonrpc', function () {
    var defaults = this.defaults = {};
    defaults.basePath = '/rpc';

    this.$get = ['$http', '$q', 'uuid4', 'toaster', '$window', function ($http, $q, uuid4, toaster, $window) {
        function jsonrpc(options, config) {
            var id = uuid4.generate();
            var payload = {
                jsonrpc: '2.0',
                method: options.method,
                id: id
            };
            if (angular.isDefined(options.data)) {
                payload.params = options.data;
            }
            var success_response = function (resp) {
                return resp.data.result;
            };
            var error_response = function (resp) {
                if (resp.status == 403) {
                    toaster.pop({
                        "type": "error",
                        "title": "Access Denied",
                        "body": resp.data.error.message
                    });
                } else if (resp.status == 400) {
                    if (resp.data.error.angularjs_pop_message) {
                        toaster.pop({
                            "type": resp.data.type || "error",
                            "title": resp.data.title || "Bad Request",
                            "body": resp.data.error.message
                        });
                    }
                } else if (resp.status == 404) {
                    toaster.pop({
                        "type": resp.data.type || "error",
                        "title": resp.data.title || "Not Found",
                        // "body": resp.data.error.message
                    });
                } else if (resp.status == 500) {
                    var body = "<p>" + resp.data.error.message + "</p>";
                    toaster.pop({
                        "type": "error",
                        "title": "Internal Server Error",
                        "body": body,
                        bodyOutputType: 'trustedHtml',
                        clickHandler: function (toaster) {
                            if(resp.data.error.exception_url != null){
                                $window.open(resp.data.error.exception_url);
                            }
                            return true;
                        }
                    });
                }
                return $q.reject(resp.data.error);
            };

            return $http
                .post(defaults.basePath + "/" + options.method, payload, config)
                .then(success_response, error_response);
        }

        jsonrpc.request = function (path, method, data, config) {
            if (arguments.length < 4) {
                config = data;
                data = method;
                method = path;
                path = null;
            }
            return jsonrpc({path: path, method: method, data: data}, config);
        };

        function Service(name, path) {
            this.serviceName = name;
            this.path = path;
        }

        Service.prototype.createMethod = function (name, config) {
            var method = name;
            var path = this.path;
            if (this.serviceName) {
                method = this.serviceName + '.' + method;
            }
            return function (data) {
                return jsonrpc.request(path, method, data, config);
            };
        };

        /** Creates a new Service with the given `name` and optional `path`. */
        jsonrpc.newService = function (name, path) {
            return new Service(name, path);
        };

        jsonrpc.newServiceMethod = function(method_id) {
            const [service_name, method_name] = method_id.split('.');
            return jsonrpc.newService(service_name).createMethod(method_name);
        };

        jsonrpc.callServiceMethod = function(method_id, data) {
            return jsonrpc.newServiceMethod(method_id)(data);
        };

        jsonrpc.setBasePath = function (path) {
            defaults.basePath = path;
            return this;
        };

        jsonrpc.getBasePath = function () {
            return defaults.basePath;
        };

        return jsonrpc;
    }];

    /** Set the base path for all JSON-RPC calls to |path|. */
    this.setBasePath = function (path) {
        defaults.basePath = path;
        return this;
    };
});

export default m.name;
